<app-pro-import-map-submit-header [activeStep]="1" (mappingStart)="loading = true" (mappingEnd)="loading = false"></app-pro-import-map-submit-header>


<div class="container">
    <app-loader color="#50e3c2" *ngIf="loading"></app-loader>

    <!-- IMPORT DETAILS START -->

    <mat-grid-list cols="3" rowHeight="2:1" class="import-details table-headers">
        <mat-grid-tile>
            <div class="tile-content details-content">{{importType}}</div>
        </mat-grid-tile>
        <mat-grid-tile>
            <div class="tile-content bullet">
                <!-- <app-bullet-icon></app-bullet-icon> -->&#8226;
            </div>
        </mat-grid-tile>
        <mat-grid-tile>
            <div class="tile-content details-content">{{importYear}}</div>
        </mat-grid-tile>
        <mat-grid-tile>
            <div class="tile-content bullet">
                <!-- <app-bullet-icon></app-bullet-icon> -->&#8226;
            </div>
        </mat-grid-tile>
        <mat-grid-tile>
            <div class="tile-content details-content">{{importQuarter}}</div>
        </mat-grid-tile>
    </mat-grid-list>

    <!-- IMPORT DETAILS END -->


    <!-- MAPPER HEADERS START -->

    <mat-grid-list cols="3" rowHeight="2:1" class="mapper-headers table-headers">
        <mat-grid-tile class="grid-tile-left">
            <div class="tile-content">IMPORTED LABELS</div>
        </mat-grid-tile>
        <mat-grid-tile class="grid-tile-center">
            <div class="tile-content">CATEGORY LABELS</div>
        </mat-grid-tile>
        <mat-grid-tile class="grid-tile-right">
            <div class="tile-content">ASSIGN</div>
        </mat-grid-tile>
    </mat-grid-list>

    <!-- MAPPER HEADERS END -->

    <!-- MAPPER TOOLS START -->

    <mat-grid-list cols="5" rowHeight="2:1" class="mapper-row" *ngFor="let header of mappedHeaders; let i = index">

        <mat-grid-tile class="input-field">
            <!-- <form class="mapper-form"> -->
            <div class="unrecognized-category-field custom-form-field">
                <!-- <mat-label>{{header}}</mat-label> -->
                <input matInput placeholder="" [value]="header.mappedFrom" [disabled]="true">
            </div>
        </mat-grid-tile>

        <mat-grid-tile>
            <app-right-arrow-icon></app-right-arrow-icon>
        </mat-grid-tile>

        <mat-grid-tile class="input-field">
            <div class="approved-cat-labels custom-form-field">
                <!-- <mat-label>Favorite food</mat-label> -->
                <mat-select [(ngModel)]="header.mappedTo" (selectionChange)="onCategoryLabelChange($event)">
                    <mat-option disabled>Select Category Label</mat-option>
                    <mat-option *ngFor="let ah of approvedCatLabels;" [value]="ah">{{ah}}</mat-option>
                </mat-select>
            </div>
        </mat-grid-tile>

        <mat-grid-tile>
            <app-right-arrow-icon></app-right-arrow-icon>
        </mat-grid-tile>

        <mat-grid-tile class="checkbox-field">
            <section class="" [ngClass]="{'selected-checkbox' : header.isAssigned, 'unselected-checkbox' : !header.isAssigned}">
                <mat-checkbox   [(ngModel)]="header.isAssigned" (click)="$event.preventDefault();$event.stopPropagation();assignMapping($event, header, i)"
                     [checked]="mappedHeaders[i].isAssigned"></mat-checkbox>
                <!-- <mat-checkbox class="example-margin" [disabled]="true">Disabled</mat-checkbox> -->
            </section>
            <!-- </form> -->
        </mat-grid-tile>

    </mat-grid-list>

    <!-- MAPPER TOOLS END -->

</div>